import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {EventResponse} from "../../../shared/model/response/event/event-response.model";
import {PaginatorState} from "primeng/paginator";
import {EventUtilService} from "../../../service/utils/event-util.service";
import {ApiResponse} from "../../../shared/model/response/ApiResponse";

@Component({
    selector: 'app-listevent',
    templateUrl: './listevent.component.html',
    standalone: false
})
export class ListeventComponent implements OnInit {

  @Input("eventPage") eventPage: ApiResponse<EventResponse[]>;
  @Output("changePageEvent") changePageEvent = new EventEmitter<PaginatorState>()

  constructor(private eventUtilService: EventUtilService) {
  }

  ngOnInit(): void {
  }

  onPageChange($event: PaginatorState) {
    this.changePageEvent.emit($event)
  }
}
